export default __webpack_public_path__ + "static/BgImg03-9324e804592426961db458da661a9fbb.webp";